module.exports = __webpack_public_path__ + "img/IMG_4690.c5dffac9.jpg";